(function (window, document) {
  'use strict';

  if (window.__boiProductLegacyRuntime) return;
  window.__boiProductLegacyRuntime = true;

  function install($) {
    if (!$ || !$.fn) return;

    if (!$.easing.easeOutQuart) {
      $.easing.easeOutQuart = function (x, time, start, change, duration) {
        var progress = time / duration - 1;
        return -change * (progress * progress * progress * progress - 1) + start;
      };
    }

    if (!$.fn.UItoTop) {
      $.fn.UItoTop = function (options) {
        var settings = $.extend({
          text: 'Top',
          min: 200,
          inDelay: 600,
          outDelay: 400,
          containerID: 'toTop',
          containerHoverID: 'toTopHover',
          scrollSpeed: 1200,
          easingType: 'linear'
        }, options || {});
        var selector = '#' + settings.containerID;

        if (!document.getElementById(settings.containerID)) {
          $('body').append(
            $('<a>', { href: '#', id: settings.containerID, 'aria-label': settings.text })
              .append($('<i>', { class: 'fas fa-long-arrow-alt-up', 'aria-hidden': 'true' }))
              .prepend($('<span>', { id: settings.containerHoverID }))
          );
        }

        var $control = $(selector);
        $control
          .hide()
          .off('.boiProductTop')
          .on('click.boiProductTop', function (event) {
            event.preventDefault();
            $('html, body').stop(true).animate({ scrollTop: 0 }, settings.scrollSpeed, settings.easingType);
          });

        $(window)
          .off('scroll.boiProductTop')
          .on('scroll.boiProductTop', function () {
            if ($(window).scrollTop() > settings.min) {
              $control.stop(true, true).fadeIn(settings.inDelay);
            } else {
              $control.stop(true, true).fadeOut(settings.outDelay);
            }
          });

        return this;
      };
    }

    if (!$.fn.tabs) {
      $.fn.tabs = function (paneSelector, options) {
        var settings = $.extend({ tabs: 'a', current: 'current', initialIndex: 0 }, options || {});
        var childPaneSelector = typeof paneSelector === 'string'
          ? paneSelector.replace(/^\s*>\s*/, '')
          : paneSelector;

        return this.each(function () {
          var $root = $(this);
          var $tabs = $root.find(settings.tabs);
          var $panes = $root.parent().children(childPaneSelector);

          if (!$panes.length) $panes = $(childPaneSelector);
          if (!$tabs.length || !$panes.length) return;

          function select(index) {
            var normalized = Math.max(0, Math.min(index, $tabs.length - 1));
            $tabs.removeClass(settings.current).attr('aria-selected', 'false');
            $panes.hide().attr('hidden', 'hidden');
            $tabs.eq(normalized).addClass(settings.current).attr('aria-selected', 'true');
            $panes.eq(normalized).removeAttr('hidden').show();
          }

          $root.attr('role', 'tablist');
          $tabs
            .attr('role', 'tab')
            .off('click.boiProductTabs')
            .on('click.boiProductTabs', function (event) {
              event.preventDefault();
              select($tabs.index(this));
            });
          $panes.attr('role', 'tabpanel');
          select(settings.initialIndex);
        });
      };
    }
  }

  if (typeof window.BoiWhenJQueryReady === 'function') {
    window.BoiWhenJQueryReady(install);
  } else if (window.jQuery) {
    install(window.jQuery);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      install(window.jQuery);
    }, { once: true });
  }
})(window, document);
